export const HR_TITLE_DISPLAY_MAP = {
  ACTIVITY_ASSISTANT: "Activity Assistant",
  ACTIVITY_COORDINATOR: "Activity Coordinator",
  ACTIVITY_DIRECTOR: "Activity Manager",
  ACTIVITY_SPECIALIST: "Activity Specialist",
  ADMINISTRATION_ASSISTANT: "Administration Assistant",
  ADMINISTRATOR: "Administrator",
  ASSISTANT_PROGRAM_DIRECTOR: "Assistant Program Director",
  BILLING_MANAGER: "Billing Manager",
  BUILDING_ENGINEER: "Building Engineer",
  BUSINESS_DEVELOPMENT_SPECIALIST: "Business Development Specialist",
  BUSINESS_INTELLIGENCE_ANALYST: "Business Intelligence Analyst",
  CAREGIVER: "Caregiver",
  CENTER_COORDINATOR: "Center Coordinator",
  CERTIFIED_MEDICATION_TECHNICIAN: "Certified Medication Technician",
  CERTIFIED_NURSE_ASSISTANT: "CNA",
  CEO: "CEO",
  CFO: "CFO",
  CHEF: "Chef",
  CHEF_ASSISTANT: "Chef Assistant",
  COMPLIANCE_MANAGER: "Compliance Manager",
  COO: "COO",
  DEPUTY_CENTER_DIRECTOR: "Deputy Center Director",
  DIRECTOR_OF_ACCOUNTING: "Director of Accounting",
  DIRECTOR_OF_OPERATIONS: "Director of Operations",
  DRIVER: "Driver",
  DRIVER_TEAM_LEAD: "Driver Team Lead",
  EXECUTIVE_ASSISTANT: "Executive Assistant",
  EXECUTIVE_CHEF: "Executive Chef",
  FINANCE_ADMIN_MANAGER: "Finance & Administration Manager",
  FINANCIAL_ANALYST: "Financial Analyst",
  FLEET_MANAGEMENT_SPECIALIST: "Fleet Management Specialist",
  FLEET_MANAGER: "Fleet Manager",
  FOOD_SERVICE_DIRECTOR: "Food Service Director",
  FOOD_SERVICES_COORDINATOR: "Food Service Coordinator",
  HANDYMAN: "Handyman",
  HEAD_NURSE: "Nursing Manager",
  HR: "HR",
  HR_AND_ADMINISTRATIVE_COORDINATOR: "HR & Administrative Coordinator",
  INTERN: "Intern",
  IT_SPECIALIST: "IT Specialist",
  IT_SUPPORT: "IT Support",
  JANITOR: "Janitor",
  KITCHEN_ASSISTANT: "Kitchen Staff",
  KITCHEN_HELPER: "Kitchen Helper",
  KITCHEN_MANAGER: "Kitchen Manager",
  LOBBY_ASSISTANT: "Lobby Assistant",
  LOBBY_MANAGER: "Lobby Manager",
  MARKETING_SPECIALIST: "Marketing Specialist",
  MEDICAL_APPOINTMENT_COORDINATOR: "Medical Appointment Coordinator",
  MEDICAL_APPOINTMENT_SCHEDULER: "Medical Appointment Scheduler",
  MEDICAL_DRIVER: "Medical Driver",
  NURSING_DIRECTOR: "Nursing Director",
  OFFICE_MANAGER: "Office Manager",
  OPRATIONS_DIRECTOR: "Center Director",
  PASTRY_CHEF: "Pastry Chef",
  PRESIDENT: "President",
  PROCESS_ASSISTANT: "Program Assistant",
  PROGRAM_ASSISTANT: "Program Assistant",
  PROGRAM_ASSISTANT_DRIVER: "Program Assistant - Driver",
  PROGRAM_ASSISTANT_MEDICAL_DRIVER: "Program Assistant - Medical Driver",
  PROGRAM_ASSISTANT_MEDICAL_DRIVER_LEAD: "Program Assistant - Medical Driver Lead",
  PROGRAM_DIRECTOR: "Program Director",
  PROJECT_ASSISTANT: "Project Assistant",
  PROJECT_DIRECTOR: "Project Director",
  QUALITY_CONTROL_SPECIALIST: "Quality Control Specialist",
  REGISTERED_NURSE: "Registered Nurse",
  SOCIAL_AND_COMMUNITY_SERVICE_MANAGER: "Social and Community Service Manager",
  SOCIAL_WORK: "Social Work",
  SOCIAL_WORK_ASSISTANT: "Social Work Assistant",
  SOCIAL_WORK_DIRECTOR: "Social Work Director",
  SOCIAL_WORKER_MANAGER: "Social Work Manager",
  SPIRITUAL_CARE_SPECIALIST: "Spiritual Care Specialist",
  TRANSPORTATION_COORDINATOR: "Transportation Coordinator",
  TRANSPORTATION_DIRECTOR: "Transportation Manager",
  VP: "VP"
};

export const getHrTitleDisplayName = (titleValue) => {
  const raw = `${titleValue || ""}`.trim();
  if (!raw) return "";
  if (HR_TITLE_DISPLAY_MAP[raw]) return HR_TITLE_DISPLAY_MAP[raw];
  if (raw.includes("_")) {
    return raw
      .toLowerCase()
      .split("_")
      .map((part) => (part ? part[0].toUpperCase() + part.slice(1) : ""))
      .join(" ");
  }
  return raw;
};
